<div class="file-upload-container"
     [ngClass]="{dropzone:displayType==='dropzone',inputUpload:displayType==='input'}"
     *ngIf="waitForUpload; else fileUploaded">
  <input type="file" class="upload-input" accept="{{fileExtension}}" (change)="onUploadInput($event)" #uploadInput/>
  <span class="file-name">{{filePath}}</span>
  <gen-button class="upload-button" [text]="fileButtonText" id="uploadButtonId" [textClass]="'uploadBtnClass'"
              [disabled] = "disabled" (click)="uploadInput.click($event)">
  </gen-button>
  <div class="drag-and-drop" (dragover)="onDrag($event)" (drop)="onDrop($event)" id="dragAndDrop" *ngIf="showDragAndDrop">
    <div class="upload-img-and-text">
      <svg width="99" height="75" viewBox="0 0 99 75">
        <g fill="none" fill-rule="evenodd">
          <path fill="#C0BFBF"
                d="M32.892 26.647l-3.384-11.76L44.59 23.28l-11.7 3.367zm-5.448-16.029L.638 18.332l16.155 56.14 43.829-12.613-11.257-39.117-21.921-12.124z"/>
          <path fill="#FFF" d="M40.781 50.953L77.146 71.03l18.412-33.226-6.4-22.24L67.113 3.409z"/>
          <path fill="#C0BFBF"
                d="M77.53 70.92L41.168 50.84l26.349-47.55 21.838 12.03.086.3-7.829 14.155 14.156 7.83.086.301L77.53 70.92zm16.668-35.807l-10.654-5.892 5.923-10.708 4.731 16.6zM91.111 14.01L66.66.522 38.365 51.648l39.941 22.064 19.732-35.628-6.927-24.075z"/>
        </g>
      </svg>
      <label class="Drag-or-upload-your-file-here">Drag or upload your PCR data ﬁle(s) here</label>
    </div>
  </div>
  <gen-info-box class="pre-upload-warning" [iconType]="'info'" [message]="preUploadWarningText" *ngIf="preUploadWarning" [backgroundCss]="preUploadWarningCss" [borderCss]="'__border'"></gen-info-box>

</div>

<ng-template #fileUploaded>
  <div class="file-upload-container">
    <gen-overlay-loader class="loader" *ngIf="uploadInProgress" [showOverlay]="false"></gen-overlay-loader>

    <ng-container *ngIf="!uploadInProgress" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit:{data:fileFields, deleteFileCallback: this.getDeleteFileCallback(),warningImageUrl:this.warningImageUrl}}">
      <ng-content></ng-content>
    </ng-container>
  </div>
</ng-template>




